import * as React from 'react';
import { Four04 } from 'gossamer-front-end';
import { Route, Routes } from 'react-router-dom';
import { PushNotificationDiagnostics } from './PushNotificationDiagnostics';

/**
 * Push Notification Routes
 *
 * Routing for push notification diagnostic and monitoring pages
 */
export const PushNotificationRoutes = (): React.JSX.Element => (
  <Routes>
    <Route path="/diagnostics" element={<PushNotificationDiagnostics />} />
    <Route path="/" element={<PushNotificationDiagnostics />} />
    <Route path="*" element={<Four04 />} />
  </Routes>
);
